import React,{useState,useEffect} from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import WhatWeDo from '../components/Whatwedo';
import WhyChooseUs from '../components/WhyChooseUs'
import KeyFeatures from '../components/KeyFeatures'
import Contactpage from '../components/contact'
import CarouselAds from '../components/carouselads';
import 'bootstrap/dist/css/bootstrap.min.css';
import AboutGlimpse from '../components/aboutglimpse';
import Footer from '../components/footer';
import api,  { API_ENDPOINTS } from "../config";
import { Helmet } from "react-helmet-async";

function Home() {
      const [services, setServices] = useState([]);
     
    // Fetch services once
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await api.get(`${API_ENDPOINTS.GET_ALL_SERVICES}`);
        setServices(res.data.services || []);
      } catch (err) {
        console.error("Failed to fetch services", err);
      }
    };
    fetchServices();
  }, []);

    return (<>
      <Helmet>
      <title>Iklim Digitals - Lead in the Digital Age</title>
      <meta
        name="description"
        content="Discover Iklim Digitals’ Web Development, Digital Advertising, and Content Production services. We help Ethiopian businesses grow with modern websites, engaging content, and strategic online campaigns."
      />
      <meta
        name="keywords"
        content="Iklim Digitals, Web Development, Digital Advertising, Content Production, marketing, branding, website design, content creation, online campaigns"
      />
    </Helmet>

        <div>
             {/* Pass services to Header & HeroSection */}
      <Header services={services} />
      <HeroSection services={services} />
            <WhatWeDo/>
            <CarouselAds/>
            <WhyChooseUs/>
            <AboutGlimpse/>
            <KeyFeatures/>
            <Contactpage/>
            <Footer/>
        </div>
   </> );
}

export default Home;
